import { getType } from 'typesafe-actions';

import { RootAction } from '../actions/types';
import {
  setMobilePrinterList,
  mobilePrinterListError,
  getMobilePrinterList,
  resetMobilePrinter,
  testMobilePrinterConnection,
  testMobilePrinterConnectionSuccess,
  testMobilePrinterConnectionError,
  testMobilePrinterConnectionWarning,
  resetTestMobilePrinterConnection,
} from '../actions/mobilePrinter.actions';
import { MobilePrinterState } from './types';
import { MOBILE_PRINTER_TEST_CONNECTION_STATUS } from '../../constants';

const initialState: MobilePrinterState = {
  printerList: {
    printers: [],
    error: null,
    hasFetched: false,
    isLoading: false,
  },
  testConnection: {
    isLoading: false,
    error: null,
    errorCode: null,
    status: null,
  },
};

export default (state: MobilePrinterState = initialState, action: RootAction): MobilePrinterState => {
  switch (action.type) {
    case getType(getMobilePrinterList): {
      return {
        ...state,
        printerList: {
          ...state.printerList,
          isLoading: true,
          hasFetched: true,
          error: null,
        },
      };
    }
    case getType(setMobilePrinterList): {
      return {
        ...state,
        printerList: {
          ...state.printerList,
          printers: action.payload.printers,
          error: null,
          isLoading: false,
        },
      };
    }
    case getType(mobilePrinterListError): {
      return {
        ...state,
        printerList: {
          ...state.printerList,
          error: action.payload.error,
          printers: [],
          isLoading: false,
        },
      };
    }
    case getType(testMobilePrinterConnection): {
      return {
        ...state,
        testConnection: {
          isLoading: true,
          error: null,
          errorCode: null,
          status: null,
        },
      };
    }
    case getType(testMobilePrinterConnectionSuccess): {
      return {
        ...state,
        testConnection: {
          isLoading: false,
          error: null,
          errorCode: null,
          status: MOBILE_PRINTER_TEST_CONNECTION_STATUS.success,
        },
      };
    }
    case getType(testMobilePrinterConnectionWarning): {
      return {
        ...state,
        testConnection: {
          isLoading: false,
          error: null,
          errorCode: null,
          status: MOBILE_PRINTER_TEST_CONNECTION_STATUS.warning,
        },
      };
    }
    case getType(testMobilePrinterConnectionError): {
      return {
        ...state,
        testConnection: {
          isLoading: false,
          error: action.payload.error,
          errorCode: action.payload.errorCode || null,
          status: MOBILE_PRINTER_TEST_CONNECTION_STATUS.error,
        },
      };
    }
    case getType(resetTestMobilePrinterConnection): {
      return {
        ...state,
        testConnection: {
          isLoading: false,
          error: null,
          errorCode: null,
          status: null,
        },
      };
    }
    case getType(resetMobilePrinter): {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
